import list from './list'
import listtoapprove from './listtoapprove'
import create from './create'
import createModal from './createModal'

export default {
  namespaced: true,
  modules: {
    list,
    listtoapprove,
    create,
    createModal
  }
}
